import React , {useState, useEffect }from 'react'
import { Autocomplete , TextField , Chip , Box} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';
const MultipleSelect = ({options = [] , label , placeholder , selectedValue , type="text" , Info , width=150, handleChangeSelection = () => {}}) => {

  const [values, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState(selectedValue);
  const handleChange = (newValue) => {
   
    setValue(newValue);
    setInputValue(newValue)
    handleChangeSelection(newValue)
  };

  useEffect(() => {
    setValue(selectedValue);
    setInputValue(selectedValue);
  }, [selectedValue]);
  return (
   <>


<Autocomplete
        multiple
        value={values}
        onChange={(event, newValue) => {
          handleChange(newValue);
        }}
        onKeyDown={(key) => key.code === 'Space' ? key.preventDefault() : null}
        id="tags-outlined"
       options={options}
        freeSolo
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip variant="outlined" sx={{backgroundColor:"#E7E9EF"}} label={option} {...getTagProps({ index })} />
          ))
        }
        sx={{
          width:width,
          
      }}
        renderInput={(params) => (
   <>
          <TextField
            {...params}
           type={type}
            value={values}
            inputValue={inputValue}
          label={label || ""}
          placeholder={placeholder || ''}
            sx={{
                ".MuiFormLabel-root": { color: "#50566E" },
                "& .MuiInputBase-root": {
                  backgroundColor: "#ffffff",
                  borderRadius: "4px",
                  marginBottom:"15px",
                  color: "#1C2238",
                  fontSize: ".875rem",
                  fontWeight: 550,
                  "& fieldset": {
                    borderColor: "#D3D8E3",
                  },
                  "&:hover fieldset": {
                    borderColor: "#D3D8E3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#D3D8E3",
                  },
                },
              }}
              size="small"
              variant="outlined"
          />
      {Info &&  <Box
            sx={{
             color:'#8792AB',
             fontSize:"13px",
             display:"flex",
             alignItems:"center",
             gap:"5px",
             marginBottom:"10px"
            }}
            ><InfoIcon fontSize='10px'/>{Info}</Box>
             }
   </>
       
        )}
      />


   </>
  )
}

export default MultipleSelect